export default "__VITE_ASSET__20ced86b__"